<xt-portal-stepper-dialog
  *transloco="let t"
  [currentStep]="currentStep"
  [stepCount]="stepCount"
  [stepHeader]="t('app.documents.questionnaires.share')"
  [config]="dialogConfig"
  [actionsTemplate]="actions"
  [contentTemplate]="content"
>
  <ng-template #content>
    <div class="questionnaire-list">
      <p class="dialog-text">
        {{ t('app.documents.questionnaires.shareToPractiotioner') }}
      </p>
      @for (questionnaire of questionnaireList; track questionnaire) {
        <div class="questionnaire-item">
          <div class="type-icon">
            <mat-icon svgIcon="text" />
          </div>
          <p class="questionnaire-item-name">{{ questionnaire.name }}</p>
        </div>
      }
    </div>

    <div class="questionnaire-approval-list">
      <div class="dialog-flex">
        <p class="dialog-text">
          {{ t('app.dialog.addDocument.approvals') }}
        </p>
        <xt-portal-button
          class="dialog-active"
          [color]="'none'"
          [width]="'small'"
          [text]="t('app.labels.add')"
          [xTentionDummyCypress]="
            'questionnaire-dialog.provider-dialog.add'
          "
          [xTentionDummyTooltip]="shareActionTooltip$ | async"
          [xTentionDummyTooltipFixByClick]="true"
          (clickEvent)="addProvider()"
        />
      </div>
      @for (provider of providersToShareWith; track provider.name) {
        <div class="questionnaire-approval-item">
          <div class="questionnaire-approval-type-icon">
            @switch (provider.providerType) {
              @case ('facility') {
                <mat-icon svgIcon="home-modern" />
              }
              @case ('station') {
                <mat-icon svgIcon="domain" />
              }
              @case ('practitioner') {
                <mat-icon svgIcon="patient" />
              }
              @default {
                <mat-icon svgIcon="domain" />
              }
            }
          </div>
          <div class="questionnaire-approval-content">
            <p class="questionnaire-approval-title">{{ provider.name }}</p>
            @switch (provider.providerType) {
              @case ('facility') {
                <p class="questionnaire-approval-text">
                  {{ t('app.dialog.addDocument.approveForFacility') }}
                </p>
              }
              @case ('practitioner') {
                <p class="questionnaire-approval-text">
                  {{
                    t('app.dialog.addDocument.approveForSelectedPractitioners')
                  }}
                </p>
              }
              @default {
                <p class="questionnaire-approval-text">
                  {{ t('app.dialog.addDocument.approveAll') }}
                </p>
              }
            }
          </div>
          <xt-portal-button
            class="item-remove"
            [color]="'none'"
            [icon]="'close'"
            [xTentionDummyCypress]="
              'questionnaire-dialog.provider-dialog.remove'
            "
            (clickEvent)="removeProvider(provider)"
          />
        </div>
      }
    </div>
  </ng-template>

  <ng-template #actions>
    <xt-portal-button
      [color]="'primary'"
      [width]="'medium'"
      [text]="t('app.wizard.ctas.skip')"
      [style]="'stroked'"
      [xTentionDummyCypress]="'questionnaire-dialog.steps.first.close'"
      (clickEvent)="closeDialog()"
    />
    <xt-portal-button
      [width]="'medium'"
      [text]="t('app.documents.questionnaires.continue')"
      [disabled]="
        !questionnaireList.length ||
        !providersToShareWith.length ||
        !(isShareActionEnabled$ | async)
      "
      [textAlign]="'center'"
      [xTentionDummyTooltip]="shareActionTooltip$ | async"
      [xTentionDummyTooltipFixByClick]="true"
      [xTentionDummyCypress]="'questionnaire-dialog.steps.first.close'"
      (clickEvent)="continueWithSharing()"
    />
  </ng-template>
</xt-portal-stepper-dialog>